<app-error-page [color]="defaultColor">
  <div class="title">
    Erro não catalogado
  </div>
  <div class="content">
    Ops, algo não deu certo, já estamos ciente do problema, tente novamente mais tarde.
  </div>
</app-error-page>
